import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AddCompanyDetailsService {

  constructor(private http: HttpClient, private httpService: HttpService) {

  }

  getClassOfCompanyList() {
      var request = {
          URL: "company/classOfCompany"
      }
      return this.httpService.get(request);
  }

  getRegistrationIDTypes() {
      var request = {
          URL: "company/registrationIdTypes"
      }
      return this.httpService.get(request);
  }

  getTypesOfCompany() {
      var request = {
          URL: "company/typesOfCompany"
      }
      return this.httpService.get(request);
  }


  getIndustryTypes() {
      var request = {
          URL: "company/indusrtyTypes"
      }
      return this.httpService.get(request);
  }
  
  financialData(addFinancialData) {

      var request = {
          URL: "financialData/add",
          DATA: addFinancialData
      }   
      return this.httpService.post(request);
  }

  getfinancialData(financialID) {

      var request = {
          URL: "financialData/getById/",
          DATA: financialID
      }
      return this.httpService.getByID(request);
  }

  getCompanyList() {
      var request = {
          URL: "companyMaster"
      }
      return this.httpService.get(request);
  }

  addCompany(newCompany) {
      var request = {
          URL: "companyMaster/add",
          DATA: newCompany
      }
      return this.httpService.post(request);
  }

  deleteCompany(companyId) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.clientUrl + 'companyMaster/delete/' + companyId, { headers: headers })
          .map(res => res);
  }

  editCompany(companyId: string) {

      var request = {
          URL: "companyMaster/getById/",
          DATA: companyId
      }
      return this.httpService.getByID(request);
  }


  getFinanceBySelectedYear(financeYear: string) {
      var request = {
          URL: "financialData/bySelectedYear/",
          DATA: financeYear
      }
      return this.httpService.getByID(request);
  }

  


  //get industry id and house id of selected company
  getSelectedCompanyDetailsFromFinCode(finCode) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.clientUrl + 'companyMaster/selectedCompanyDetailsFromFinCode?Fincode=' + finCode,{headers:headers})
          .map(res => res);
  }

  //get industry and housing wise peers
  getindustryAndHousingWisePeers(industryCode, housingCode) {

      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.clientUrl + 'companyMaster/industryAndHousingWisePeers?IndustryCode=' + industryCode + '&HousingCode=' + housingCode,{headers:headers})
          .map(res => res);
  }

  addCompanyFromSetup(data){
      var request = {
          URL: "companyMaster/setUpByStandalon",
          DATA: data
      }
      return this.httpService.post(request);
  }

  generateSuparAdmin(data){
      var request = {
          URL: "user/createSuperAdmin",
          DATA: data
      }
      return this.httpService.post(request);
  }
}